export default "__VITE_ASSET__e5b6fe42__"